import {gql} from '@apollo/client'
export const upPassword=gql`
mutation Mutation($oldPwd: String!, $newPwd: String!) {
  updatePassword(oldPwd: $oldPwd, newPwd: $newPwd)
}
  
`
export const sendNotification = gql`
mutation sendNotification( $message: String,
  $messageType: String,
  $bigPictureUrl: String,
  $thumbnailUrl: String,
  $linkUrl: String,
  $usernames: [String],
  $title: String,
  $eventId: String,
  $showType: String) {
sendNotification(message: $message,
  messageType: $messageType,
  bigPictureUrl: $bigPictureUrl,
  thumbnailUrl: $thumbnailUrl,
  linkUrl: $linkUrl,
  usernames: $usernames,
  title: $title,
  eventId: $eventId,
  showType: $showType) {
  Result
  ResultMessage
  ReturnValue
  Msg
  TS
}
}
`
export const whiteList = gql`
query whiteList {
  whiteList {
    data {
        Id
        UserName
    }
  }
}
`